import { useIntl } from '@/intl'
import { useState } from 'react'

export function useTexts() {
  const { translate } = useIntl()
  const [api] = useState(() => ({
    cancelButtonTitle: translate({ id: 'duplicateOrderModal.cancelButton.title' }),
    duplicateButtonTitle: translate({ id: 'duplicateOrderModal.duplicateButton.title' }),
    duplicateAlso: (type: 'p' | 'd' | 's' | 'mixed') =>
      translate({
        id:
          type === 'p'
            ? 'duplicateOrderModal.duplicateAlso.dropoff'
            : type === 'd' || type === 's'
              ? 'duplicateOrderModal.duplicateAlso.pickup'
              : 'duplicateOrderModal.duplicateAlso.bulk',
      }),
    duplicateAlsoBulk: translate({ id: 'duplicateOrderModal.duplicateAlso.bulk' }),
    emptyOrdersTitle: translate({ id: 'duplicateOrderModal.title.emptyOrders' }),
    warningCardEmptyOrdersTitle: translate({ id: 'duplicateOrderModal.invalid.emptyOrders.title' }),
    warningCardEmptyOrdersDesc: translate({
      id: 'duplicateOrderModal.invalid.emptyOrders.description',
    }),
    title: (type: string) =>
      translate({
        id: type === 'p' ? 'duplicateOrderModal.title.pickup' : 'duplicateOrderModal.title.dropoff',
      }),
    titleBulk: translate({ id: 'duplicateOrderModal.title.bulk' }),
    subtitle: ({ name, serviceTime }: { name: string; serviceTime: string | null }) =>
      !!serviceTime
        ? translate({
            id: 'duplicateOrderModal.subtitle.serviceTime',
            values: { name, serviceTime },
          })
        : translate({
            id: 'duplicateOrderModal.subtitle',
            values: { name },
          }),
    subtitleBulk: (ordersAmount: number) =>
      translate({
        id:
          ordersAmount > 1
            ? 'duplicateOrderModal.subtitle.bulk.plural'
            : 'duplicateOrderModal.subtitle.bulk.singular',
        values: { ordersAmount },
      }),
    transactionWarningCardTitle: translate({
      id: 'duplicateOrderModal.transaction.warningCard.title',
    }),
    transactionWarningCardDescription: translate({
      id: 'duplicateOrderModal.transaction.warningCard.description',
    }),
    warningCardTitle: (ordersAmount: number) =>
      translate({ id: 'duplicateOrderModal.warningCard.title', values: { ordersAmount } }),
    warningCardDescription: (ordersAmount: number) =>
      translate({ id: 'duplicateOrderModal.warningCard.description', values: { ordersAmount } }),

    thisOrder: translate({ id: 'duplicateOrderModal.thisOrder' }),
    theEntireRecurrence: translate({ id: 'duplicateOrderModal.theEntireRecurrence' }),
    duplicateAlsoTooltip: (type: 'p' | 'd' | 's' | 'mixed') =>
      translate({
        id:
          type === 'p'
            ? 'duplicateOrderModal.duplicateAlsoTooltip.pickup'
            : type === 'd' || type === 's'
              ? 'duplicateOrderModal.duplicateAlsoTooltip.dropoff'
              : 'duplicateOrderModal.duplicateAlsoTooltip.mixed',
      }),

    entireRecurrenceOptionDisabledTooltip: translate({
      id: 'duplicateOrderModal.entireRecurrenceOptionDisabledTooltip',
    }),

    reccurentOrdersDuplicateWarning: (mode: 'single' | 'bulk' | 'empty', startDate?: string) =>
      translate({
        id:
          mode === 'single'
            ? 'duplicateOrderModal.recurrence.warning.single'
            : 'duplicateOrderModal.recurrence.warning.bulk',
        values: { startDate },
      }),

    startDateOutsidePlanningRangeWarning: (mode: 'single' | 'bulk' | 'empty') =>
      translate({
        id:
          mode === 'single'
            ? 'duplicateOrderModal.recurrence.outsideplanningrange.warning.single'
            : 'duplicateOrderModal.recurrence.outsideplanningrange.warning.bulk',
      }),
  }))

  return api
}
